var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelCalendarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#FFF",
  rx: 2,
  transform: "translate(3 3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19.005 3C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3ZM9.428 14.571h-2.57v1.29c0 .7.573 1.282 1.281 1.282h1.29zm7.715 0H14.57v2.572h1.29c.7 0 1.282-.574 1.282-1.282zm-3.858 0h-2.57v2.572h2.57zm-3.857-3.857h-2.57v2.572h2.57zm7.715 0H14.57v2.571h2.572zm-3.858 0h-2.57v2.571h2.57zm2.576-3.857H8.139c-.7 0-1.282.574-1.282 1.282v1.29h10.286v-1.29c0-.7-.574-1.282-1.282-1.282"
}))));
export default SvgGemChannelCalendarFilled;